import { MomentDateAdapter } from '@angular/material-moment-adapter';

export class CustomMomentDataAdapter extends MomentDateAdapter {
  getFirstDayOfWeek(): number {
    return 0;
   }
}
